// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 138) return "static/css/138.86069f96d23774911020.lib.css";
	if (chunkId === 678) return "static/css/678.5117a3ad546afb80c264.css";
	// return url for filenames based on template
	return undefined;
};